<template>
  <dl class="grid gap-y-4" style="grid-template-columns: fit-content(10rem) 1fr">
    <template v-for="({ label, text, url }, i) in data" :key="i">
      <template v-if="label && text">
        <dt class="pr-2 fw-bold">
          <span>
            <base-interpolator :content="formatBarcodeText(label)">
              <template #product-link="{ args: [pid] }">
                <vf-link
                  data-product-barcode-link
                  :to="getBarcodeLink()"
                >
                  {{ pid }}
                </vf-link>
              </template>
            </base-interpolator>:
          </span>
        </dt>
        <dd>
          <base-link v-if="url" :to="url">
            {{ text }}
          </base-link>
          <span v-else>
            <base-interpolator :content="formatBarcodeText(text)">
              <template #product-link="{ args: [pid] }">
                <vf-link
                  data-product-barcode-link
                  :to="getBarcodeLink()"
                >
                  {{ pid }}
                </vf-link>
              </template>
            </base-interpolator>
          </span>
        </dd>
      </template>
    </template>
  </dl>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
}>()

const { productId } = usePdp()
const { formatBarcodeText, getBarcodeLink } = useBarcode(productId.value)
</script>
